import { render } from "./PzldjdxRoomSearch.vue?vue&type=template&id=4b837b50&ts=true"
import script from "./PzldjdxRoomSearch.vue?vue&type=script&lang=ts"
export * from "./PzldjdxRoomSearch.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/ogino/data/project/mad/e-planning/p-dojo/git/p-dojo-place/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__